import { render } from "./index.vue?vue&type=template&id=a7c6f37e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a7c6f37e&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c6f37e"]])

export default __exports__